<template>
  <CheckInput
    v-bind="$attrs"
    :id="$attrs.id || 'GenderCheckInput'"
    :class="$attrs.class || 'field required'"
    :validations="$attrs.validations || { required: true }"
    :options="genderOptions"
    @input="$emit('input', $event)"
  />
</template>
<script>
import { GenderOptions } from '@/helpers/persona'
import CheckInput from '@/components/ui/newComponents/CheckInput.vue'
export default {
  name: 'GenderCheckInput',
  components: {
    CheckInput,
  },
  inheritAttrs: false,
  emits: ['input'],
  data() {
    return {
      genderOptions: GenderOptions,
    }
  },
}
</script>
<style lang="scss"></style>
